module.exports = __webpack_public_path__ + "739759648fac503e2b64c4abac23435b.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/paper_airplane.png
// module id = 618
// module chunks = 0